import { useCallback } from "react"
import { batch, useComputed, useSignal } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { adminSkuModalData, adminSkuSavingData, adminSkuSelectedRows, isOpenModalAdminSku, isReloadAdminSkuData, isMerged } from "../@signals"


export default function useAdminSkuModal(field="") {
    const localValue = useComputed(() => adminSkuModalData.value[field])
    const isLoading = useSignal(false)
    const { showToast } = useToast()

    const handleChange = useCallback((newValue, newData={}) => {
        adminSkuModalData.value = {
            ...adminSkuModalData.value,
            [field]: newValue,
            ...newData
        }
    }, [])

    const __clearMergeSignals = () => {
        if (!adminSkuSelectedRows.value.length) {
            isOpenModalAdminSku.value = false
            isLoading.value = false
        }
    }

    const __removeLoadingList = skuID => {
        adminSkuSavingData.value = adminSkuSavingData.value.filter(v => v.skuID !== skuID)
        adminSkuSelectedRows.value = adminSkuSelectedRows.value.filter(v => v.skuID !== skuID)
        batch(() => {
            __clearMergeSignals()
            isReloadAdminSkuData.value = true
        })
    }

    const handleMerge = useCallback(() => {
        isLoading.value = true
        const newSku = adminSkuModalData.value.sku
        const oldSkus = adminSkuSelectedRows.value

        showToast.confirm(`Are you sure merge ${oldSkus.length} SKUs?`, {
            onSubmit: () => {
                isMerged.value = true
                oldSkus.map(oldSkuID => getSubmit(`${BACKEND_APIS.SKU_DATA}/merge-async/${oldSkuID}/into/${newSku}`)
                    .then(() => __removeLoadingList(oldSkuID))
                    .catch(() => console.error(`Error Merged ${oldSkuID} into ${newSku}`)))
                return `${oldSkus.length} SKUs merged into ${newSku}`
            },
            onError: () => isLoading.value = false
        })
    }, [])

    return {
        localValue: localValue.value,
        isLoading: isLoading.value,

        handleChange,
        handleMerge
    }
}